module.exports = { "default": require("core-js/library/fn/math/expm1"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/expm1.js
// module id = 1398
// module chunks = 2